export class WeatherCloudModel {
  public WindGustMin: number;
  public WindGustMax: number;
  public PrecipMin: number;
  public PrecipMax: number;
  public PtypeMin: number;
  public PtypeMax: number;
  public WindSpdMin: number;
  public WindSpdMax: number;
  public TempMin: number;
  public TempMax: number;
  public VtimesEnd: Date;
  public VtimesStart: Date;
}
